<div class="w-full flex flex-col gap-4 p-4">
    <div
        class="w-full flex sm:flex-row flex-col items-center justify-between gap-4"
    >
        <h1 class="text-2xl font-bold">Lista de Versões</h1>

        <app-button
            (click)="incluir()"
            variant="success"
            class="md:max-w-45 w-full"
        >
            Incluir
        </app-button>
    </div>

    <div
        class="w-full grid lg:grid-cols-[2fr_1fr_1fr_1fr] md:grid-cols-2 grid-cols-1 gap-4 items-end"
    >
        <app-input-search
            [(ngModel)]="filtro"
            label="Filtrar"
            placeholder="Filtrar Versão"
            (keydown.enter)="carregarLista()"
            (search)="carregarLista()"
        ></app-input-search>

        <app-date #dataInicial [(ngModel)]="dataInit"></app-date>

        <app-date #dataFinal [(ngModel)]="dataFim"></app-date>

        <app-date-navigator
            (alterouData)="alterouData($event)"
        ></app-date-navigator>
    </div>

    <p-table
        [paginator]="true"
        [rows]="qtdLinhas || 7"
        [totalRecords]="versao.length"
        [value]="versao"
        [lazy]="false"
    >
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th class="w-[40%] min-w-30">Descrição</th>
                <th class="w-[20%] min-w-10">Data</th>
                <th class="w-[15%] min-w-10">Versão</th>
                <th class="w-[15%] min-w-10">Obrigatória</th>
                <th class="w-[10%] min-w-10">Ações</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr>
                <td>{{ rowData.Descricao }}</td>
                <td>{{ rowData.Data | data }}</td>
                <td>{{ rowData.VersaoNumero }}</td>
                <td>{{ rowData.Obrigatoria }}</td>
                <td>
                    <app-opcoes-table
                        [value]="rowData"
                        [opcoes]="opcoesTable"
                    ></app-opcoes-table>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<app-modal-versionamento-cadastro
    [modalVisible]="modalVisible"
    [data]="null"
    (closeModal)="modalVisible = false"
>
</app-modal-versionamento-cadastro>
